import { PopUp } from '@components/PopUp'
import { useTranslation } from 'react-i18next'

import { Container, LabelDescription, LabelHint } from './PopUpDelete.styled'

interface Props {
  title: string
  description: string
  hint?: string
  type?: 'validate' | 'destroy'

  onSubmit: () => void
  onClose: () => void

  onSubmitLabel?: string
}

export const PopUpDelete = (props: Props): JSX.Element => {
  const { title, description, hint, onSubmit, onClose, onSubmitLabel, type = 'destroy' } = props

  const { t } = useTranslation()

  return (
    <PopUp
      type={type}
      title={title}
      onSubmitLabel={onSubmitLabel || t('components_PopUpDelete_label_submit')}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <Container>
        <LabelDescription>{description}</LabelDescription>
        {hint && <LabelHint>{hint}</LabelHint>}
      </Container>
    </PopUp>
  )
}
